/** @module Enums */ /** typedoc */

export enum CreditCardEnum {
    Visa = 'Visa',
    MasterCard = 'MasterCard'
}
